// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottomAd_box":"bottomAd_box-2V2RI73a"};